import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-protectedfooter',
  templateUrl: './protectedfooter.component.html',
  styleUrls: ['./protectedfooter.component.scss']
})
export class ProtectedfooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
